import React from 'react'
import PropTypes from 'prop-types'
import { ScrollErrorForm, FullPageSpinner } from 'components'
import { FlowActions } from '../components'
import { Formik } from 'formik'

const propTypes = {
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  companyDetails: PropTypes.shape({
    name: PropTypes.string.isRequired,
    billingCountry: PropTypes.string.isRequired,
    billingStreet: PropTypes.string.isRequired,
    billingCity: PropTypes.string.isRequired,
    billingState: PropTypes.string.isRequired,
    billingPostalCode: PropTypes.string.isRequired,
  }),
  contactDetails: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
  }),
}

const defaultProps = {
  companyDetails: null,
  contactDetails: null,
}

function ReviewPlanInformationForm({
  initialValues,
  onSubmit,
  contactDetails,
  companyDetails,
}) {
  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit}>
      {({ isSubmitting }) => {
        return (
          <ScrollErrorForm>
            {isSubmitting && <FullPageSpinner showBackground={true} />}
            <>
              <div className="form-header">
                <h3>Company details</h3>
              </div>
              <div className="company-details-container">
                <dl>
                  <div className="company-details">
                    <dt>Company name</dt>
                    <dd>{companyDetails?.name}</dd>
                  </div>
                  <div>
                    <dt>Country</dt>
                    <dd>{companyDetails?.billingCountry}</dd>
                  </div>
                  <div>
                    <dt>Street address</dt>
                    <dd>{companyDetails?.billingStreet}</dd>
                  </div>
                  <div>
                    <dt>City</dt>
                    <dd>{companyDetails?.billingCity ?? '-'}</dd>
                  </div>
                  <div>
                    <dt>State/Province/Region</dt>
                    <dd>{companyDetails?.billingState ?? '-'}</dd>{' '}
                  </div>
                  <div>
                    <dt>Zip code</dt>
                    <dd>{companyDetails?.billingPostalCode}</dd>
                  </div>
                </dl>
              </div>
              <div className="form-header no-border">
                <h3>Contact details</h3>
              </div>
              <div className="contact-details-container">
                <dl>
                  <div className="contact-details">
                    <dt>First name</dt>
                    <dd>{contactDetails?.firstName}</dd>
                  </div>
                  <div>
                    <dt>Last name</dt>
                    <dd>{contactDetails?.lastName}</dd>
                  </div>
                  <div>
                    <dt>Title</dt>
                    <dd>{contactDetails?.title}</dd>
                  </div>
                  <div>
                    <dt>Contact phone</dt>
                    <dd>{contactDetails?.phone}</dd>
                  </div>
                  <div>
                    <dt>Contact email</dt>
                    <dd>{contactDetails?.email ?? '-'}</dd>{' '}
                  </div>
                </dl>
              </div>
            </>
            <FlowActions submitContent="Continue" />
          </ScrollErrorForm>
        )
      }}
    </Formik>
  )
}

ReviewPlanInformationForm.propTypes = propTypes
ReviewPlanInformationForm.defaultProps = defaultProps

export default ReviewPlanInformationForm
